
import Picker from '../Picker'

import translations from './PickersList.translations'

export default {
  components: {
    Picker,
  },
  props: {
    breakpoint: {
      type: Number,
      default: 0,
    },
    category: {
      type: String,
      default: '',
    },
    pickers: {
      type: Array,
      required: true,
    },
    shown: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      displayAllPickers: false,
    }
  },
  computed: {
    translations: () => translations,

    pickersToDisplay() {
      if (this.displayAllPickers) {
        return this.pickers
      }

      if (this.isPickersLengthHigherThanMax) {
        return this.pickers.slice(0, this.maximumAmountOfPickersToShow)
      }

      return this.pickers.slice(0, this.shown)
    },

    isPickersLengthHigherThanMax() {
      return this.pickers.length > this.shown
    },

    remainingPickersCount() {
      return this.pickers.length - this.maximumAmountOfPickersToShow
    },

    maximumAmountOfPickersToShow() {
      return this.shown - 1
    },

    togglerLabel() {
      const { showMore, showLess } = this.translations

      return this.displayAllPickers
        ? this.$t(showLess)
        : this.$t(showMore, { remaining: this.remainingPickersCount })
    },

    selectedPickerIndex() {
      return this.pickers.findIndex(({ selected }) => {
        return selected
      })
    },
    isSelectedPickerFurtherInList() {
      return this.selectedPickerIndex >= this.maximumAmountOfPickersToShow
    },
    isBreakpointSet() {
      return this.breakpoint > 0
    },
    isPickersListTuck() {
      return !this.displayAllPickers
    },
  },

  methods: {
    togglePickersDisplay() {
      this.displayAllPickers = !this.displayAllPickers
    },
    setPickersDisplay(value) {
      this.displayAllPickers = value
    },
  },
}
